module.exports = __webpack_public_path__ + "static/media/9.4086c162.svg";